// extracted by mini-css-extract-plugin
export var displayNone = "_rv-6";
export var imgContainer = "_rv-2";
export var overflowHidden = "_rv-3";
export var productInfoCardButtonContainer = "_rv-5";
export var productTitleText = "_rv-4";
export var rightArrow = "_rv-1";
export var rightArrowContainer = "_rv-0";